import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledSideMenuMobileComponent, decorationsStyles } from "./side-menu-mobile-component.scss";
import { SideMenuMobile } from "/constants/links";
import OutlineButtonComponent from "../../../outline-button/outline-button-component";
import { isAndroid } from "/utils/mobile";
import { ONELINK_MOBILE_APP_URL, LOGIN_PAGE_LINK } from "/constants/links";
import { normalizeUrl } from "/utils/url";
import { trackEvent } from "/services/bigbrain-service";
import { SIDE_MENU_LINK_CLICK, HP_STORE_CLICKED } from "/constants/bigbrain-event-types";
import SignupLeftDecoration from "/static/svg/decorators/signup/signup-decoration-left.svg";
import SignupRightDecoration from "/static/svg/decorators/signup/signup-decoration-right.svg";
import PictureComponent from "components/core/picture/picture-component";
import { withGenericConfig } from "/contexts/generic-config-context";
class SideMenuMobileComponent extends PureComponent {
    downloadMobileApp() {
        const { isAndroidPhone } = this.state;
        trackEvent(HP_STORE_CLICKED, {
            kind: isAndroidPhone ? "android" : "ios"
        });
    }
    trackLinkClick(event) {
        const { target } = event;
        const href = normalizeUrl(target.href);
        trackEvent(SIDE_MENU_LINK_CLICK, {
            kind: href,
            placement: "mobile"
        });
    }
    componentDidMount() {
        this.setState({
            isAndroidPhone: isAndroid()
        });
    }
    renderAppButton() {
        const { isAndroidPhone } = this.state;
        const imgSrc = isAndroidPhone ? "/static/img/apps/google_play.png" : "/static/img/apps/app_store.png";
        return /*#__PURE__*/ _jsx(PictureComponent, {
            src: imgSrc
        });
    }
    render() {
        const { open, scrollMode, translate, mobileHeaderLinks } = this.props;
        const header = mobileHeaderLinks;
        return /*#__PURE__*/ _jsx(StyledSideMenuMobileComponent, {
            className: classnames(`side-menu-mobile`, {
                open,
                "scroll-mode": scrollMode
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "side-menu-mobile-dialog",
                children: [
                    /*#__PURE__*/ _jsx("section", {
                        className: "links-section",
                        children: Object.keys(header.links).map((title)=>/*#__PURE__*/ _jsx("div", {
                                className: "side-nav-link-wrapper",
                                children: /*#__PURE__*/ _jsx(OutlineButtonComponent, {
                                    url: header.links[title],
                                    text: translate(title),
                                    buttonStyle: "textual",
                                    linkClassName: "side-nav-link"
                                })
                            }, title))
                    }),
                    /*#__PURE__*/ _jsxs("section", {
                        className: "buttom-bottons",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "left-decoration decoration",
                                children: /*#__PURE__*/ _jsx(SignupLeftDecoration, {}, "left-decoration decoration")
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                className: "download-app-wrapper af-smart-button",
                                href: ONELINK_MOBILE_APP_URL,
                                onClick: this.downloadMobileApp,
                                children: this.renderAppButton()
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "right-decoration decoration",
                                children: /*#__PURE__*/ _jsx(SignupRightDecoration, {}, "right-decoration")
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isAndroidPhone: false
        };
        this.downloadMobileApp = this.downloadMobileApp.bind(this);
    }
}
SideMenuMobileComponent.defaultProps = {
    open: false,
    mobileHeaderLinks: SideMenuMobile
};
export default withGenericConfig(SideMenuMobileComponent);
